export enum ReviewType {
    FINANCE_MANAGER = 'Finance Manager',
    MANAGER = 'Manager'
}
